import React from "react";
import { IQuizProps, IQuizState, IRootState } from "../../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { quizRequest, quizSubmitRequest } from "../../action";
import Loader from "../../components/Loader/Loader";
import { AlertBox, ConfirmBox } from "../../helper/SweetAlert";
import { toast } from "react-toastify";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import { quizReducer } from "../../reducer/Quiz";

//import { Link } from "react-router-dom";
import redflag from "../../assets/images/quiz/red_flag.jpg";
import whiteflag from "../../assets/images/quiz/white_fleg.jpg";
//import QuizReviewFunctionality from "./quiz-review-functionality";
//import Modal from "react-bootstrap/Modal";

import {
  Table,
  Image,
} from "react-bootstrap";

interface questionReview {
  questionNumber: any;
  question: any;
  flagValue: any;
}
let reviewQuestion: questionReview[] = [];

class Quiz extends React.Component<IQuizProps, IQuizState> {
  constructor(props: any) {
    super(props);
    this.state = {
      questions: {},
      userAnswer: {},
      questionNumbers: {},
      currentQues: 1,
      maxQuestions: 80,
      quizSummaryData: {},
      quizSubmitted: 0,
      flag: false,
      questionFlags:{},
      flaggedQuestions: {},
      unanswered: {},
      onReviewPage: 0,
    };
    if (!(this.state.quizSummaryData["status"] === 1)) {
      this.startTimer(3600);
    }
  }

  toggleImage = (index: any) => {
    this.setState((prevState) => ({ flag: !prevState.flag }));

    if(this.state.questionFlags[index] === undefined) {
      //console.log("I am in 1")
      this.state.questionFlags[index] = !this.state.flag;
    } else {
      //console.log("I am in 2");
      this.state.questionFlags[index] = !this.state.questionFlags[index];
    }    
    //console.log(this.state.flag);
    //console.log(this.state.questionFlags[index]);
  };

  getFlagQuestions(item: any, indexNumber: any) {
    if(this.state.questionFlags[item.id] === undefined) {
      this.state.questionFlags[item.id] = !this.state.flag;
    }

    let Key: questionReview = {
      questionNumber: indexNumber,
      question: item.question,
      flagValue: this.state.questionFlags[item.id],
    };

    const checkQuestion: any = reviewQuestion.find(
      (element) => element.question === item.question
    );
    if (!checkQuestion) {
      reviewQuestion.push(Key);
    } else {
      
      if (checkQuestion.flagValue !== this.state.questionFlags[item.id]) {
        reviewQuestion.splice(reviewQuestion.indexOf(checkQuestion), 1, Key);
      }
    }
  }

  renderReview() {
    var flaggedQues = [];
    const flagQuestion = reviewQuestion;
    for(var i=0;i<flagQuestion.length;i++) {
      //console.log("top videos",displayVideos[i]);
      if(flagQuestion[i].flagValue === true) {
        flaggedQues.push(flagQuestion[i])
      }
    }
    console.log("flagQuestion---",flagQuestion );
    this.setState({
      quizSubmitted: 1
    });
    //alert("wwww"+this.state.quizSubmitted)
    this.setState({flaggedQuestions:flaggedQues });
    //console.log(flaggedQues, "flaggedQues");
  }

  startTimer(duration: number) {
    var timer = duration;
    var minutes;
    var seconds;
    var interval = setInterval(function () {
      minutes = parseInt(timer / 60 + "", 10);
      seconds = parseInt((timer % 60) + "", 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var elem = document.getElementById("timer");
      if (elem) {
        elem.innerHTML = minutes + ":" + seconds;
      }

      var quizSubmitted = document.getElementById("quizSubmitted");
      if (timer === 60 && quizSubmitted && quizSubmitted.innerHTML === "0") {
        toast(
          "You have only 1 minute left, quiz will be submitted automatically once time is up!",
          {
            position: "top-center",
            autoClose: 60000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }

      if (quizSubmitted && quizSubmitted.innerHTML === "1") {
        clearInterval(interval);
      }

      if (--timer < 0) {
        clearInterval(interval);
        timer = duration;
        let element = document.getElementById("completeQuiz");
        if (element) {
          element.click();
        }
      }
    }, 1000);
  }

  componentDidMount() {
    this.getQuizData();
    window.scrollTo(0, 0);
  }

  componentDidUpdate = (prevProps: any) => {
    const { quizReducer } = this.props;
    if (
      quizReducer &&
      quizReducer.quizData &&
      Object.entries(quizReducer.quizData).length
    ) {
      const { quizData } = quizReducer;
      if (!this.state.questions[0]) {
        this.setState({
          questions: quizData,
          maxQuestions: quizData.length - 1,
        });
        for (var i = 0; i < quizData.length - 1; i++) {
          this.state.userAnswer[quizData[i].id] = "";
          this.state.questionFlags[quizData[i].id] = false;
          this.state.questionNumbers[quizData[i].id] = i + 1;
        }
      }
    }

    if (
      quizReducer &&
      quizReducer.quizSummaryData &&
      Object.entries(quizReducer.quizSummaryData).length
    ) {
      const { quizSummaryData } = quizReducer;
      if (this.state.quizSummaryData["correctAnswersCnt"] === undefined) {
        console.log("quizSummary", quizSummaryData);
        this.setState({
          quizSummaryData: quizSummaryData,
        });
      }
    }
  };

  getQuizData = () => {
    const { quizReducer } = this.props;
    if (quizReducer) {
      if (this.props.quizData) {
        this.props.quizData();
      }
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  handleQuestionSelection = (questionDivId: string, AnswerChoices: any) => {
    let questionId = questionDivId.split("_")[0];
    let choiceNumber = questionDivId.split("_")[1];
    if (!choiceNumber) {
      console.log("empty");
    } else {
      console.log(choiceNumber);
    }
    let choice = document.getElementById(questionDivId);
    let selectedChoices = 1;
    if (choice != null) {
      //when choice selected and if choice doesnot exist below condition will be executed and choice will be highlighted
      if (this.state.userAnswer[questionId].indexOf(choiceNumber) !== -1) {
        this.state.userAnswer[questionId] = this.state.userAnswer[
          questionId
        ].replace(choiceNumber + "+", "");
        choice.style.border = "2px solid #bbb3b3";
        let tickIcon = document.getElementById(questionDivId + "_icon");
        console.log(
          tickIcon,
          "----------------------------------------------------------------------------"
        );
        if (tickIcon != null) {          
          tickIcon.classList.add("hide-element");
        }
      } else {
        //when choice selected and if choice exists below will be executed and choice will be un selected
        if (this.state.userAnswer[questionId].match(/[+]/gi) != null) {
          selectedChoices =
            this.state.userAnswer[questionId].match(/[+]/gi).length + 1;
        }
        //console.log("selectedChoices--",selectedChoices);
        if (selectedChoices > AnswerChoices) {
          console.log("Exceeded choices, remove prev selected one");
          let choicesArray = this.state.userAnswer[questionId].split("+");
          choicesArray.pop();
          let popNum = choicesArray.pop();
          let popChoice = document.getElementById(questionId + "_" + popNum);
          if (popChoice != null) {
            popChoice.style.border = "2px solid #bbb3b3";
          }
          let tickIcon = document.getElementById(
            questionId + "_" + popNum + "_icon"
          );
          if (tickIcon != null) {
            tickIcon.classList.add("hide-element");
            console.log(
              "hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
            );
          }
          choicesArray.push(choiceNumber);
          this.state.userAnswer[questionId] = choicesArray.join("+");
          this.state.userAnswer[questionId] =
            this.state.userAnswer[questionId] + "+";
          console.log("new choices -- ", this.state.userAnswer[questionId]);
          choice.style.border = "2px solid #d5a917";
        } else {
          choice.style.border = "2px solid #d5a917";
          this.state.userAnswer[questionId] =
            this.state.userAnswer[questionId] + choiceNumber + "+";
        }

        let tickIcon = document.getElementById(questionDivId + "_icon");
        if (tickIcon != null) {
          tickIcon.classList.remove("hide-element");
        }
      }

    }
  };
  handleReviewPageValidation= (index: any, id: any, noOfAnswers: any, item: any) => {    
    let questionDivId = `${id}_${index}`;
    let questionId = questionDivId.split("_")[0];
    let userAnswers = this.state.userAnswer[questionId];
    if(!this.state.questionFlags[id] && (!userAnswers || userAnswers === "")) {
        AlertBox({
        type: "warning"
      });
      return ;
    }
    if(userAnswers !== "" && (userAnswers.split("+")).length ) {
      if((userAnswers.split("+")).length >= 1) {
        var answersLen = (userAnswers.split("+")).length;
        if(answersLen-1 !== noOfAnswers) {
          AlertBox({
            type: "warning",
            text: "You must select "+noOfAnswers+" answers to continue."
          });
          return ;
        }
      }
    }    
    this.getFlagQuestions(item, index);
    let markedCount = 0;
    reviewQuestion.forEach((item, index) => {
      //console.log(item);
      item.flagValue? markedCount = markedCount+1:markedCount = markedCount;
    });
    if(markedCount === 0) {
      this.handleReviewPage();
    } else {       
      document.body.className = "";
      this.renderReview();
      this.handleReviewQuestions();
    }
  };

  handleNextButton = (index: any, id: any, noOfAnswers: any) => {
    let questionDivId = `${id}_${index}`;
    let questionId = questionDivId.split("_")[0];
    let userAnswers = this.state.userAnswer[questionId];
    if(!this.state.questionFlags[id] && (!userAnswers || userAnswers === "")) {
        AlertBox({
        type: "warning"
      });
      return ;
    }
    if(userAnswers !== "" && (userAnswers.split("+")).length ) {
      if((userAnswers.split("+")).length >= 1) {
        var answersLen = (userAnswers.split("+")).length;
        if(answersLen-1 !== noOfAnswers) {
          AlertBox({
            type: "warning",
            text: "You must select "+noOfAnswers+" answers to continue."
          });
          return ;
        }
      }

    }
    if (this.state.currentQues < this.state.maxQuestions) {
      this.setState({
        currentQues: this.state.currentQues + 1,
      });
      if (this.state.flag) {
        this.setState((prevState) => ({ flag: !prevState.flag }));
      }    
    }
  };

  handlePrevButton = () => {
    if (this.state.currentQues > 1) {
      this.setState({     
        currentQues: this.state.currentQues - 1,
      });
      if (this.state.flag) {
        this.setState((prevState) => ({ flag: !prevState.flag }));
      }
    }
  };

  handleReviewQuestions = () => {
    let element: HTMLElement = document.getElementsByClassName(
      "swal2-container"
    )[0] as HTMLElement;
    if (element) {
      element.style.display = "none";
    }
    toast.dismiss();
    const { userAnswer } = this.state;
    document.getElementById("review-questions")?.setAttribute("style","display:block"); 
    document.getElementById("quiz-section")?.setAttribute("style","display:none");     
  }

  handleSubmitQuiz = () => {
    document.getElementById("review-questions")?.setAttribute("style","display:none"); 
    document.getElementById("quiz-section")?.setAttribute("style","display:block"); 
  }

  handleQuizSubmit = () => {
    this.setState({
      quizSubmitted: 1,
    });
    let element: HTMLElement = document.getElementsByClassName(
      "swal2-container"
    )[0] as HTMLElement;
    if (element) {
      element.style.display = "none";
    }
    toast.dismiss();
    const { userAnswer } = this.state;
    this.handleSubmitQuiz();
    const { submitQuizData } = this.props;

    if (submitQuizData) {
      this.setState({
        userAnswer: this.state.userAnswer,
      });
      const data = {
        userAnswer,
      };
      submitQuizData({
        ...data,
      });
      //const { quizReducer } = this.props;
    }
  };

  // handleQuestion(q: any) {
  //   return (
  //     <a onClick={() => {
  //       console.log('clickeddd');
  //     }}>
  //     {{q}}
  //   </a>
  //   )
  // };

  handleQuestion = (q: any) => {
    return { q };
  };

  handleCompleteQuiz = async (markedCount: any, index: any, itemId: any, noOfAnswers: any) => {
    const { userAnswer } = this.state;
    var questionIds = Object.keys(userAnswer);
    var notAnswered = "";
    var message =
      "<span class='swal2-content-span1'>Do you want to complete quiz? You cannot revert back once you submit it</span>";
      for (var u = 0; u < questionIds.length; u++) {
      if (userAnswer[questionIds[u]].length === 0) {
        notAnswered += this.state.questionNumbers[questionIds[u]] + ",";
      }
    }
    if (notAnswered.length > 0) {
      var notAnsweredList = notAnswered
        .substring(0, notAnswered.length - 1)
        .split(",");
      var temp = 0;
      for (var i = 0; i < notAnsweredList.length; i++) {
        for (var j = i + 1; j < notAnsweredList.length; j++) {
          if (parseInt(notAnsweredList[i]) > parseInt(notAnsweredList[j])) {
            temp = parseInt(notAnsweredList[i]);
            notAnsweredList[i] = notAnsweredList[j];
            notAnsweredList[j] = temp + "";
          }
        }
      }
      this.setState ({unanswered:notAnsweredList})
      //console.log(notAnsweredList);
      console.log("state unanswered",this.state.unanswered)
     // message =
     //   "<span class='swal2-content-span'><span style='color: orange'> You have not completed question(s) -<a onClick=this.handleQuestion> " +
    //  notAnsweredList +
      //  "</a>" +
      //  "</span><br><br>Still do you want to complete quiz? You cannot revert back once you submit it</span>";
      // message =
      //   "<span class='swal2-content-span'><span style='color: orange'> You have not completed question(s) -<a onClick={handleQuestion}>" + notAnsweredList + "</a>"  +
      //   "</span><br><br>Still do you want to complete quiz? You cannot revert back once you submit it</span>";

      // message =
      // "<span class='swal2-content-span'><span style='color: orange'> You have not completed question(s) -<a>" + {handleQuestion(notAnsweredList[0])} + "</a>"  +
      // "</span><br><br>Still do you want to complete quiz? You cannot revert back once you submit it</span>";

      // message =
      // "<span class='swal2-content-span'><span style='color: orange'> You have not completed question(s) - " + this.handleQuestion(notAnsweredList[0])  +
      // "</span><br><br>Still do you want to complete quiz? You cannot revert back once you submit it</span>";

      // message =
      // "<span class='swal2-content-span'><span style='color: orange'> You have not completed question(s) - "

      // +
      // console.log('list', notAnsweredList)
      // notAnsweredList.map(
      //   (item: any, index: any) => {
      //     return (
      //       <a
      //       key={index}
      //       onClick={() => {
      //         console.log('clickeddd')
      //         // this.handleQuestion(notAnsweredList[0]);
      //       }}>
      //         {item}
      //       </a>
      //       // <tr key={index}
      //       // style={index % 2 === 0?{backgroundColor:"#ebe99b"}:{}}>
      //       //   <td className="text-left">{item.userName}</td>

      //       // </tr>
      //     );
      //   }
      // )

      // +

      // "</span><br><br>Still do you want to complete quiz? You cannot revert back once you submit it</span>";
    }
    toast.dismiss();
    let questionDivId = `${itemId}_${index}`;
    let questionId = questionDivId.split("_")[0];
    let userAnswers = this.state.userAnswer[questionId];
  if(!this.state.questionFlags[itemId] && (!userAnswers || userAnswers === "")) {
    AlertBox({
      type: "warning"
    });
    return ;
  } 
  if(userAnswers !== "" && (userAnswers.split("+")).length ) {
    if((userAnswers.split("+")).length >= 1) {
      var answersLen = (userAnswers.split("+")).length;
      if(answersLen-1 !== noOfAnswers) {
        AlertBox({
          type: "warning",
          text: "You must select "+noOfAnswers+" answers to continue."
        });
        return ;
      }
    }
  }
  if(markedCount !== 0) {
    message = "<span class='swal2-content'> You have flagged "+markedCount+" questions. Are you sure you want to complete the Quiz?</span>";
    const { value } = await ConfirmBox({
    title: "<span class='swal2-title-span1'></span>",
    background: "#fff",
    html: message,
    cancelButtonClass: "popup-btn",
    confirmButtonClass: "popup-btn", 
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Finish test",
    cancelButtonText: "Review questions",
    });
    if (!value) {
      document.body.className = "";
      this.renderReview();
      this.handleReviewQuestions();
    } else {
      document.body.className = "";
      this.handleQuizSubmit();
    }     
  } else {
    var message =
      "<span class='swal2-content-span1'>Are you sure you want to complete the Quiz? You cannot revert back once you submit it</span>";
    
    const { value } = await ConfirmBox({
      title: "<span class='swal2-title-span1'></span>",
      background: "#fff",
      html: message,
      cancelButtonClass: "popup-btn",
      confirmButtonClass: "popup-btn", 
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6"
      });
      if (!value) {
        return;
      } else {
        document.body.className = "";
        this.handleQuizSubmit();
      }
  }
};

handleReviewPage = () => {
  AlertBox({
    type: "warning",
    text: "There are no flagged questions. Please complete the quiz."
  });
  return ;
}

  createChoices(item: any) {
    // console.log("item--------------------------------",item)
    if (item.choices) {
      var alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      return Object.keys(item.choices).map((key, i) => (
        <div className="row choice-row">
          <div className="col-lg-12 col-md-12">
            <div
              id={`${item.id}_${i + 1}`}
              className="col-lg-10 col-md-10 col-sm-10 ml-new5 choice"
              onClick={() => {
                this.handleQuestionSelection(
                  `${item.id}_${i + 1}`,
                  `${item.noOfAnswers}`
                );
              }}
            >
              <Table
                responsive
                className="choice-table"
                cellSpacing="0"
                cellPadding="0"
              >
                <tbody>
                  <tr>
                    <td className="choice-alphabet">{alphabets[i]}</td>
                    <td className="choice-desc">
                      <div className="choice-text">{item.choices[key]}</div>
                      <div
                        className="social-networks hide-element"
                        id={`${item.id}_${i + 1}_icon`}
                      >
                        <i>&#10004;</i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      ));
    }
  }

  render() {
    //const { quizReducer } = this.props;
    return (
      <>
        <div id="quizSubmitted"  style={{ display: "none" }}>{this.state.quizSubmitted}</div>
        {this.state.quizSummaryData["status"] === 1 ? (
          <div className="main-section module-custom-main">
            <div className="col-lg-12 col-md-12">
              <section>
                <div className="row">
                  <div className="col-lg-12 col-md-12 ml-new5 mt-3 btn-row">
                    <h1 className="summary-title" style={{}}>
                      Quiz Summary
                    </h1>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-4 ml-new5 mt-3 btn-row">
                    {/* {this.state.quizSummaryData["percentage"] >= 85 ? (
                      <div className="passImage"></div>
                    ) : (
                      null
                    )} */}
                    <div className="answer-details">
                      {this.state.quizSummaryData["answeredcount"]} question
                      {this.state.quizSummaryData["answeredcount"] === 1
                        ? ""
                        : "s"}{" "}
                      answered
                      <div>
                        <span className="tick-mark">
                          <i>&#10004;</i>
                        </span>
                        <span className="answerDiv">
                          {this.state.quizSummaryData["correctAnswersCnt"]}{" "}
                          correct answer
                          {this.state.quizSummaryData["correctAnswersCnt"] === 1
                            ? ""
                            : "s"}
                        </span>
                      </div>
                      <div>
                        <span className="cross-mark">
                          <i>&#10008;</i>
                        </span>
                        <span className="answerDiv">
                          {this.state.quizSummaryData["wrongAnswersCnt"]}{" "}
                          incorrect answer
                          {this.state.quizSummaryData["wrongAnswersCnt"] === 1
                            ? ""
                            : "s"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-3 ml-new5 mt-3 btn-row">
                    <h3 className="score-title">
                      YOUR SCORE: <br />
                      <span className="score-percentage">
                        {this.state.quizSummaryData["percentage"]}%
                      </span>
                    </h3>
                    {this.state.quizSummaryData["percentage"] >= 85 ? (
                      <h4 className="summary-text">
                        {" "}
                        Congratulations. You Passed.
                      </h4>
                    ) : (
                      <h4 className="summary-text-fail">
                        Sorry. You've failed.
                      </h4>
                    )}
                  </div>
                  <div className="col-lg-3 col-md-3 ml-new5 mt-3 btn-row">
                    <div className="emptyDiv"></div>
                    <button
                      type="submit"
                      className="btn-submit btn btn-primary summary-btn"
                    >
                      <a href="#">Review</a>
                     {/* <a href="/student/review-quiz">Review</a>*/}
                    </button>
                    <br />
                    <br />
                    <button
                      type="submit"
                      className="btn-submit btn btn-primary summary-btn"
                    >
                      <a href="/student/quiz">New Quiz</a>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ) : (
          <div id="quiz-section" className="main-section module-custom-main">
            <div className="col-lg-12 col-md-12">
              <div className="container">
                <div className="title video-search">
                  <div className="row">
                    <div className="quiz-head-section">
                      <h4 className="video-title">
                        Quiz                        
                       {/*} <button
                          onClick={() => {
                            this.renderReview();
                          }}
                          type="submit"
                          className="btn-review summary-btn"
                        >
                          <a href="/student/quiz-review-functionality">
                            Review
                          </a>
                        </button>*/}
                        <span className="border-heading"></span>
                      </h4>
                      <div className="timer-section" id="timer">
                        60:00
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section className="">
                {this.state.questions && !this.state.questions[0] ? (
                  <Loader />
                ) : (
                  this.state.questions.map((item: any, index: any) => (
                    <div
                      className={
                        this.state.currentQues === index + 1
                          ? "container"
                          : "container hide-element"
                      }
                      id={`ques${index}`}                    >
                      <div className="row">
                        <div className="col-lg-12 col-md-12 mr-5 mt-3 ml-new5 d-flex example-parent">
                          <span className="mr-3 question p-2 col-example">
                            {index + 1}.{item.question}
                          </span>
                          <span
                            className="flag ml-auto p-2 col-example"
                            style={{ width: "80px" }}
                            onClick={() => {
                              this.toggleImage(item.id);
                            }}
                          >
                            {this.state.questionFlags[item.id] ? (
                              <i className="fas fa-bookmark" style={{fontSize:"48px",color:"#CEB86A"}}></i>
                            ) : (
                              <i className="far fa-bookmark" style={{fontSize:"48px"}}></i>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 mr-5 mt-3 ml-new5 mb-2">
                          <span className="mr-3 ques-message">
                            {item.comment}
                          </span>
                        </div>
                      </div>

                      {this.createChoices(item)}

                      <div className="row">
                        <div className="col-lg-10 col-md-10 ml-new5 mt-3 btn-row">
                        <div id = "leftbox">
                        <span>
                            <button
                              className={
                                this.state.currentQues === 1
                                  ? "btn prev-btn mb-5 ml-auto hide-element"
                                  : "btn prev-btn mb-5 ml-auto"
                              }
                              type="submit"
                              onClick={() => {
                                this.handlePrevButton();
                              }}
                            >
                              Previous Question
                            </button>
                          </span>
                          </div>
                        
                        <div id = "middlebox">
                        <span>
                        {this.state.onReviewPage === 1 ? (
                          <button
                              className={
                                this.state.currentQues ===
                                this.state.maxQuestions
                                  ? "btn quiz-summary-btn mb-5 ml-auto "
                                  : "btn quiz-summary-btn mb-5 ml-auto"
                              }
                              type="button"
                              onClick={() => {
                                document.body.className = "";
                                this.handleReviewPageValidation(index+1, item.id, item.noOfAnswers,item);                           
                                
                                
                              
                              }}
                            >
                              Summary Page
                            </button>
                        ) :
                        ("")}

                            
                          </span>
                        </div>
                        
                        <div id = "rightbox">
                        <span>
                            <button
                              className={
                                this.state.currentQues ===
                                this.state.maxQuestions
                                  ? "btn next-btn mb-5 ml-auto hide-element"
                                  : "btn next-btn mb-5 ml-auto"
                              }
                              type="submit"
                              onClick={() => {
                                this.getFlagQuestions(item, index + 1);
                                this.handleNextButton(index+1, item.id, item.noOfAnswers);
                              }}
                            >
                              Next Question
                            </button>
                          </span>
                          <span>
                            <button
                              className={
                                this.state.currentQues < this.state.maxQuestions
                                  ? "btn next-btn mb-5 ml-auto hide-element"
                                  : "btn next-btn mb-5 ml-auto"
                              }
                              type="submit"
                              onClick={() => {
                                this.getFlagQuestions(item, index + 1);
                                let markedCount = 0;
                                reviewQuestion.forEach((item, index) => {
                                  //console.log(item);
                                  item.flagValue? markedCount = markedCount+1:markedCount = markedCount;
                                });
                                this.handleCompleteQuiz(markedCount, index+1, item.id, item.noOfAnswers);
                              }}
                            >
                              Complete Quiz
                            </button>
                            <button
                              className="btn next-btn mb-5 ml-auto hide-element"
                              type="submit"
                              id="completeQuiz"
                              onClick={() => {
                                this.handleQuizSubmit();
                              }}
                            >
                              SubmitQuiz
                            </button>
                          </span>
			                  </div>                 

                          
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </section>
            </div>
          </div>
        )}

        
      
        <div id="review-questions" className="main-section1 module-custom-main" style={{display:"none"}} >
          <div className="col-lg-12 col-md-12">
            <div className="container">
              <Row className="col-lg-12 col-md-12 quiz-review-head">
                  <Col lg={"12"} md={"12"} style={{border:"1px solid", borderRadius: "10px"}}>
                    {this.state.flaggedQuestions.length > 0 ? this.state.flaggedQuestions.length : "" }  
                    <div style={{ borderLeft:"1px solid",marginLeft:"30px",display:"inline"}}></div><div style={{paddingLeft:"20px", display:"inline"}}>Flagged Questions</div>
                  </Col>
                </Row>
              {this.state.flaggedQuestions.length > 0 ? (
                <>
                  {this.state.flaggedQuestions.map((item: any, index: any) => {
                    var answered = "Answered";
                    //console.log("unanswered",this.state.unanswered + "-- "+item.questionNumber);
                    if(this.state.unanswered !== "" && this.state.unanswered.length > 0) {
                      console.log('list', this.state.unanswered)
                    var notAnsweredList = this.state.unanswered;
                    notAnsweredList.map(
                    (item1: any, index1: any) => {                      
                      if(item1 === item.questionNumber.toString()) {
                        answered = "Unanswered";
                      }
                    } )
                    }
                    
                    return(
                  <Row className="col-lg-12 col-md-12 quiz-review-body">
                    <Col lg={"12"} md={"12"} >
                      <div style={{marginTop:"20px"}}>
                          {/*<div className="d-flex flex-row flex-wrap">*/}
                          <div style={{ width: "8%", float: "left"}}>
                            <i className="fas fa-bookmark" style={{fontSize:"48px",color:"#CEB86A"}}></i>
                            </div>
                            <div style={{ width: "75%", float: "left"}}>
                             <span style={{fontWeight:"bold"}}> Question {item.questionNumber} </span><br></br>
                            {item.question} 
                          </div>
                          {/*<div style={{ width: "10%", float: "left", paddingLeft: "10px"}}> <span className="answerCircle">{answered}</span> </div>*/}
                          <div style={{ width: "5%", float: "right", paddingLeft: "25px"}}><a   onClick={() => {                                       
                            document.getElementById("review-questions")?.setAttribute("style","display:none"); 
                            document.getElementById("quiz-section")?.setAttribute("style","display:block");  
                            this.setState({currentQues: item.questionNumber});  
                            this.setState({onReviewPage: 1})
                                        }}
 title="View flagged answer" style={{color: "#000"}}><i className="fas fa-arrow-circle-right" style={{fontSize:"36px"}}></i></a></div>
                      </div>
                    </Col>
                  </Row>
                    )
                   })} 
                   <Row>
                    <Col>&nbsp;</Col><Col>&nbsp;</Col><Col>&nbsp;</Col>
                    <Col>
                    <button
                              className="btn mb-5 ml-auto review-finish-btn" 
                              id="completeQuiz"
                              type="submit"
                              onClick={() => {                                
                                this.handleQuizSubmit();
                              }}
                            >
                              Finish Test
                            </button></Col>
                            <Col>&nbsp;</Col><Col>&nbsp;</Col><Col>&nbsp;</Col>
                              
                  </Row>                 
                </>
                
              ) : (
                <Row className="col-lg-12 col-md-12">
                  <Col md={{ span: 6, offset: 3 }}>
                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                      <h3 style={{ color: "red" }}>Attempt the Quiz first</h3>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  quizReducer: state.quizReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    quizData: () => {
      dispatch(quizRequest());
    },
    submitQuizData: (data: any) => {
      dispatch(quizSubmitRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);
